export const NOT_SUPPORTED_TITLE = 'Not supported'
export const NOT_SUPPORTED_SECTION_DESCRIPTION = 'This section is not available on this network.'
